/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-09-24 11:08:41
 */

import { fetchstrategyList, fetchStrategyStatus, fetchDeleteStrategy, fetchStrategyDragSort } from "@/api/modules/strategy";
import { ProFormSwitch, ProFormText, ProTable, ProColumns, ProFormSelect, DragSortTable } from "@ant-design/pro-components";
import { useEffect, useState, useRef } from "react";
import { InfoCircleOutlined, InfoOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { message, Modal, Space, Popover, Button, Tag, Divider, Table } from "antd";
import { useNavigate } from "react-router-dom";
import { useDebounce } from "@/utils/util";
import { fetchADAccountList } from "@/api/modules/AdAccount";
import { PlusOutlined } from "@ant-design/icons";
import LoadingPage from "@/components/loading";
import EmptyRule from "@/assets/images/emptyRule.png";
import BatchOperation from "@/assets/icons/rule/icon_batch.png";
import AdvModal from "@/pages/AutomatedRules/ManageRules/component/AdvModal";

import "./index.less";
import { useSelector } from "react-redux";
const AutomatedRules = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const actionRef = useRef();
	const RULECOUNT = useRef<number>();
	const [filterParams, setFilterParams] = useState({});
	const [selctedRowKeys, setSelectedRowKeys] = useState([]);
	const [advOptions, setAdvOptions] = useState([]);
	const [PageLoading, setPageLoading] = useState(false);
	const [ruleList, setRuleList] = useState([]);
	const [total, setTotal] = useState(0);
	const [showAdvModal, setShowAdvModal] = useState(false);
	const { currentUser } = useSelector(state => state.global);
	useEffect(() => {
		// 初始化广告账户列表
		setPageLoading(true);
		fetchADAccountList()
			.then(res => {
				const data = res.data?.list;
				if (!data || data.length === 0) {
					return;
				}
				setTotal(res.data.total);
				setAdvOptions(data);
			})
			.finally(() => {
				setPageLoading(false);
			});
		getRuleList();
		setFilterParams({});
		/** 获取规则列表 */
	}, []);

	const getRuleList = async params => {
		const res = await fetchstrategyList({
			...params
		});
		if (res.code === 200) {
			RULECOUNT.current = res.data.total;
			setRuleList(res.data?.list);
		}
	};

	const searchRules = useDebounce(value => {
		setFilterParams(...value);
		getRuleList(...value);
	}, 800);

	const handleUpdateStrategyStatus = (strategyId, status) => {
		fetchStrategyStatus({ strategyId, status: status ? 1 : 0 }).then(res => {
			if (res.code === 200) {
				if (status) {
					message.success(t("Automated rule turned on"));
				} else {
					message.success(t("Automated rule turned off"));
				}
				const newRuleList = ruleList.map(item => {
					if (item.strategyId === strategyId) {
						item.isEnable = status;
					}
					return item;
				});
				setRuleList(newRuleList);
			} else {
				message.error(res.message);
			}
		});
	};

	const ruleRemove = async id => {
		fetchDeleteStrategy({ id: id }).then(res => {
			if (res.code === 200) {
				message.success(t("message.success"));
				fetchstrategyList().then(res => {
					RULECOUNT.current = res.data.list?.length;
					setRuleList(res.data?.list);
				});
			}
		});
	};

	const handleDragSortEnd = async (beforeIndex: number, afterIndex: number, newDataSource: T[]) => {
		const newList = [];

		const list = newDataSource.map((item, index) => {
			newList.push({
				...item,
				orderNum: index
			});
			return {
				id: item.strategyId,
				orderNum: index
			};
		});

		setRuleList(newList);
		fetchStrategyDragSort({
			sortList: list
		}).then(res => {
			console.log("res", res);
			if (res.code === 200) {
				message.success(t("message.update.success"));
				if (actionRef?.current) {
					actionRef?.current?.reload();
				}
			} else {
				message.error(res.message);
			}
		});
		/** 排序 */
	};
	const columns: ProColumns<any>[] = [
		{
			title: "",
			dataIndex: "sort",
			width: 40
		},
		// Table.EXPAND_COLUMN,
		{
			title: t("automatedRules.manageRules.table.column1"),
			key: "strategyName",
			dataIndex: "strategyId",
			render: (_, record) => {
				return (
					<div className="strategyNameCell">
						<div className="strategySwitch">
							<ProFormSwitch
								className="switch"
								name="status"
								fieldProps={{
									checked: record.isEnable,
									onChange: value => {
										handleUpdateStrategyStatus(record.strategyId, value);
									}
								}}
							/>
						</div>
						<div className="strategyName">
							<span>{record.strategyName}</span>
							<span>
								{record.bindAdvList.length > 0 &&
									record.bindAdvList.map(item => {
										return (
											<Tag style={{ marginRight: 10 }} key={item.advId}>
												{item.advName}
											</Tag>
										);
									})}
							</span>

							{/* {record.bindAdvList?.length > 1 && (
								<span>
									{record.bindAdvList?.[0]?.advName} and {record.bindAdvList?.length - 1} others &nbsp;
									<Popover
										placement="right"
										content={
											<div>
												{record.bindAdvList.length > 0 &&
													record.bindAdvList.map(item => {
														return <p key={item.advId}>{item.advName}</p>;
													})}
											</div>
										}
									>
										<InfoCircleOutlined />
									</Popover>
								</span>
							)} */}
							{/* {record.bindAdvList?.length === 1 && <span>{record.bindAdvList?.[0]?.advName}</span>} */}
						</div>
					</div>
				);
			},
			width: "80%"
		},
		{
			title: t("automatedRules.manageRules.table.column2"),
			key: "operation",
			align: "left",
			width: 160,
			render: (_, record) => (
				<Space>
					<a key="modify" onClick={() => navigate(`/Automated/edit?id=${record.strategyId}`)}>
						{t("automatedRules.manageRules.table.edit")}
					</a>
					{/** 复制规则为携带规则信息，跳转到编辑也*/}
					<a key="duplicate" onClick={() => navigate(`/Automated/edit?id=${record.strategyId}&dup=1`)}>
						{t("automatedRules.manageRules.table.copy")}
					</a>

					<a
						key="share"
						onClick={() => {
							const input = document.getElementById(`share_url_${record.strategyId}`) as HTMLInputElement;
							input.select();
							document.execCommand("copy", true);
							message.success("Copied to clipboard. You can share this rule with other users and they will be able to use it.");
						}}
					>
						{t("automatedRules.manageRules.table.share")}
					</a>

					<a
						key="delete"
						onClick={async () => {
							Modal.confirm({
								title: t("automatedRules.manageRules.table.delete.confirm.title"),
								content: t("automatedRules.manageRules.table.delete.confirm.content"),
								// cancelText: "Cancel",
								okText: t("action.button.delete"),
								closable: true,
								width: 600,
								okButtonProps: {
									danger: true
								},
								onOk: async () => {
									ruleRemove(record.strategyId);
								}
							});
						}}
					>
						{t("automatedRules.manageRules.table.delete")}
					</a>

					<input
						key="input"
						style={{ position: "absolute", clip: "rect(0 0 0 0)" }}
						id={`share_url_${record.strategyId}`}
						readOnly
						value={`${document.location.host}/Automated/edit?id=${record.strategyId}&share=${record.shareCode}`}
					/>
				</Space>
			)
		}
	];

	if (PageLoading) {
		return <LoadingPage />;
	}

	if (!RULECOUNT.current) {
		return (
			<div className="emptyRuleContent">
				<div className="emptyImage">
					<img src={EmptyRule} alt="" />
				</div>
				<div className="emptyText">{t("automatedRules.manageRules.blank.message")}</div>
				<Button className="emptyButton" onClick={() => navigate("/Automated/edit")}>
					{t("automatedRules.manageRules.blank.button")}
				</Button>
			</div>
		);
	}

	const renderBatchOperation = () => {
		if (selctedRowKeys.length) {
			return (
				<div className="batchOperation">
					<img src={BatchOperation} />
					<span className="batchBefore">{t("automatedRules.batch.binding.strtegy.bulk operation")}</span>
					<Button
						type="primary"
						onClick={() => {
							setShowAdvModal(true);
						}}
					>
						{t("automatedRules.batch.binding.strtegy.bulk operation.item")}
					</Button>
				</div>
			);
		} else {
			return (
				<div className="batchOperation">
					<img src={BatchOperation} />
					<span className="batchBefore">{t("automatedRules.batch.binding.strtegy.bulk operation")}</span>
					<Button disabled>{t("automatedRules.batch.binding.strtegy.bulk operation.item")}</Button>
				</div>
			);
		}
	};

	return (
		<div className="rules-containers">
			<div className="ruleContent">
				<p className="PageTitle">{t("automatedRules.manageRules.title")}</p>
				<div className="ruleInfo">
					<span>
						<InfoOutlined style={{ borderRadius: "50%", background: "#FFAF41", color: "#fff", marginRight: 5 }} />
						{t("automatedRules.manageRules.tip")}
					</span>
				</div>
				<DragSortTable
					actionRef={actionRef}
					columns={columns}
					rowKey="strategyId"
					dataSource={ruleList}
					search={false}
					pagination={false}
					request={async () => {
						const res = await getRuleList();

						return {
							data: res.data.list,
							total: res.data.total
						};
					}}
					optionsRender={() => {
						return [
							<div className="OptionRender" key="operation">
								{RULECOUNT && (
									<div className="ruletitle">
										{t("automatedRules.manageRules.limit.text")}
										<span className="currentCount">{RULECOUNT.current}</span> /{currentUser.currentPlan?.ruleCreationLimit}
									</div>
								)}
								<div className="createButton">
									<Button onClick={() => navigate("/Automated/edit")}>{t("automatedRules.manageRules.createRule")}</Button>
								</div>
							</div>
						];
					}}
					toolBarRender={() => [
						<div key="select" className="startegy_list_search">
							<ProFormText
								fieldProps={{
									onChange: ({ target: { value } }) => {
										searchRules({
											...filterParams,
											name: value
										});
									}
								}}
								placeholder={t("automatedRules.manageRules.search.text")}
								style={{ width: 200 }}
								allowClear
							/>
						</div>
					]}
					dragSortKey="sort"
					rowSelection={{
						onChange: (selectedRowKeys, selectedRows) => {
							setSelectedRowKeys(selectedRows);
						}
					}}
					onDragSortEnd={handleDragSortEnd}
				/>
				{renderBatchOperation()}
			</div>
			<AdvModal
				open={showAdvModal}
				onCancel={() => setShowAdvModal(false)}
				ruleList={selctedRowKeys}
				reloadTable={() => {
					if (actionRef.current) {
						actionRef?.current?.reload();
					}
				}}
			/>
		</div>
	);
};

export default AutomatedRules;
